import { Layout, theme, Typography } from "antd";
import AddCompany from "../components/companies/AddCompany";
import CompaniesTable from "../components/companies/CompaniesTable";

const { Content } = Layout;

const Companies = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ ŞİRKƏT
          </Typography.Title>
          <AddCompany />
          <Typography.Title level={5} className="titles-start">
            ŞİRKƏTLƏR
          </Typography.Title>
          <CompaniesTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Companies;
